import moment from 'moment';
import { getToken } from './authentication';

import { logout } from './authentication';
import { webSocketApiUrlsDictionary } from '../constants';

moment.locale('pt-br');

export const API_KEY = 'api-key';

export const TIMEZONE_GMT = -(new Date().getTimezoneOffset() / 60);

/**
 * Does a request to the backend API corresponding to defined options
 * @param {String} url The url to make the request
 * @param {Object} options The object containing defined request options
 */
const doRequest = async (url, options) => {
  const defaultUrl =
    process.env.REACT_APP_API_URL || `${window.location.origin}/api/v1/`;
  const theme = localStorage.getItem('theme');
  const BACKEND_API_ENDPOINT =
    webSocketApiUrlsDictionary[theme]?.apiUrl || defaultUrl;

  let apiKey = localStorage.getItem(API_KEY);

  if (!apiKey) {
    const response = await fetch(window.location.href);
    apiKey =
      response.headers.get('Api-Key') || process.env.REACT_APP_TENANT_KEY;
    if (apiKey) {
      localStorage.setItem(API_KEY, apiKey);
    }
  }

  let defaultHeaders = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Platform: 'DASHBOARD',
    'Api-Key': localStorage.getItem(API_KEY),
    'X-Timezone-Offset': TIMEZONE_GMT,
  };

  const { method, body } = options;

  try {
    const authToken = getToken();

    if (authToken) defaultHeaders.Authorization = `${authToken}`;

    const raw = await fetch(BACKEND_API_ENDPOINT + url, {
      method,
      headers: defaultHeaders,
      body,
    });

    if (!url.includes('login') && !url.includes('2fa/')) {
      if (raw.status === 401) {
        logout();
        alert(
          'Suas credenciais foram expiradas. Você será redirecionado para a tela de Login.',
        );
        window.alert = () => (document.location.href = '/');
      }
    }

    if (url.includes('report/assessment/unified')) {
      if (raw.status !== 500 && raw.status !== 403) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-unificado-${JSON.parse(body).from_date}-${
              JSON.parse(body).to_date
            }.pdf`,
          );
          // 3. Append to html page
          document.body.appendChild(link);
          // 4. Force download
          link.click();
          // 5. Clean up and remove the link
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('report/assessment/users')) {
      if (raw.status !== 500 && raw.status !== 403) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-individual-${JSON.parse(body).from_date}-${
              JSON.parse(body).to_date
            }.zip`,
          );
          // 3. Append to html page
          document.body.appendChild(link);
          // 4. Force download
          link.click();
          // 5. Clean up and remove the link
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('report/xlsx/chargepoints')) {
      if (raw.status !== 500 && raw.status !== 403) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-estacoes-${new Date().getFullYear()}-${
              new Date().getMonth() + 1
            }-${new Date().getDate()}.xlsx`,
          );
          // 3. Append to html page
          document.body.appendChild(link);
          // 4. Force download
          link.click();
          // 5. Clean up and remove the link
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('/meter-values')) {
      if (raw.status !== 500 && raw.status !== 403) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-transaction-${url.substring(
              url.indexOf('transactions/') + 13,
              url.lastIndexOf('/meter-values'),
            )}-meter-values-${new Date().getFullYear()}-${
              new Date().getMonth() + 1
            }-${new Date().getDate()}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('report/xlsx/transactions')) {
      if (raw.status === 200) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-recargas-${new Date().getFullYear()}-${
              new Date().getMonth() + 1
            }-${new Date().getDate()}.xlsx`,
          );
          // 3. Append to html page
          document.body.appendChild(link);
          // 4. Force download
          link.click();
          // 5. Clean up and remove the link
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('report/xlsx/ocpptags')) {
      if (raw.status === 200) {
        raw.blob().then((blob) => {
          const href = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute(
            'download',
            `relatorio-ocpp-tags-${new Date().getFullYear()}-${
              new Date().getMonth() + 1
            }-${new Date().getDate()}.xlsx`,
          );
          // 3. Append to html page
          document.body.appendChild(link);
          // 4. Force download
          link.click();
          // 5. Clean up and remove the link
          link.parentNode.removeChild(link);
        });
      }
    } else if (url.includes('log/download')) {
      if (raw.status === 200) {
        const blob = await raw.blob();

        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;

        const urlParams = new URLSearchParams(url.split('?')[1]);
        const tenant = urlParams.get('tenant');
        const dateFrom = urlParams.get('dateFrom');
        const dateTo = urlParams.get('dateTo');

        const formattedTenant = tenant?.replace(/\s/g, '_').toLowerCase();
        let filename;

        if (dateFrom && dateTo) {
          filename = `${formattedTenant}-${dateFrom}_to_${dateTo}.zip`;
        } else {
          const formattedDate = moment().utc().format('YYYYMMDD-HHmmss');
          filename = `${formattedTenant}-${formattedDate}.txt`;
        }

        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();

        await new Promise((resolve) => setTimeout(resolve, 500));

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(href);
      }
    } else if (url.includes('report/user/permissions')) {
      if (raw.status === 200) {
        const data = await raw.json();
        const hasDisableTransactionOption = data.hasDisableTransactionOption;
        return hasDisableTransactionOption;
      }
    }

    return raw;
  } catch (e) {
    // throw e;
    return {};
  }
};

export default doRequest;
